import { logoIcon, thanksIcon, selfixLogoIcon } from "../../assets";
import "./index.css";
import strings from "../../localization";

export default function CustomerThanksView() {

  return <div className="customer-thanks-view">
    <img src={logoIcon} alt="customer-thanks" className="customer-thanks-view-logo" />
    <img src={thanksIcon} alt="customer-thanks" className="customer-thanks-view-thanks" />
    <h1>{strings.thanksForYourTime}</h1>
    <p>{strings.thankYouForWorkingWithUs} <br /> {strings.youCanNowCloseYourBrowser}</p>
    <img src={selfixLogoIcon} alt="customer-thanks" className="customer-thanks-view-selfix-logo" />
  </div>;
}